export const comMenus = {
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/en/',
            url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
            alt: 'Raisin',
        },
    ],
    navItems: [],
    actionItems: [
        {
            id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
            title: 'My Account',
            href: '/en/login/',
            type: 'login',
        },
    ],
};
//# sourceMappingURL=comMenus.js.map